<img
  class="dynamic-shimmer"
  [class.custom-logo]="(config$ | async)?.uiConfiguration?.loadingImage"
  [src]="(config$ | async)?.uiConfiguration?.loadingImage"
  alt="Loading Image"
/>
